import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams  } from '@angular/common/http';

import { Observable, forkJoin } from 'rxjs';


import * as theGlobals from 'src/app/globals';
import { IHearingDate } from 'src/app/classes/hearing-date';

@Injectable()
export class PublicService {

    private myUrl = theGlobals.setEnv().funcUrl;
    private myAuditFlag = theGlobals.setEnv().auditFlag;

    constructor(private http: HttpClient) {

    }
    // send messages/data to console - iff auditFlag is true
    doAudit(msg: any, headr: string = '') {
      if (this.myAuditFlag) {
        if (headr.length > 0) {
          console.log(headr);
        }
        console.log(msg);
      }
    }
    searchCase(searchObj: any): Observable<any> {
      const xUrl = this.myUrl + '/application/search/generic';
      return this.http.post<any>(xUrl,searchObj );
    }
    getCaseStatusAndHearingInfo(applicationId: number): Observable<any> {
      const xUrl = this.myUrl + '/application/search/statusinfo/' + applicationId;
      return this.http.get<any[]>(xUrl);
    }
    getHearingDatesForAgenda(): Observable<any[]> {
        const xUrl = this.myUrl + '/hearing/agenda';
        return this.http.get<any[]>(xUrl);
    }
    generateAgenda(hearingId: number): Observable<Blob> {
      const xUrl = this.myUrl + '/agenda/generateagenda/hearing/' + hearingId;
      return this.http.get(xUrl,{ responseType: 'blob' });
    }
    generateMinutes(hearingId: number): Observable<Blob>
    {
      const xUrl = this.myUrl + '/minutes/hearing/' + hearingId;
      return this.http.get(xUrl,{ responseType: 'blob' });
    }
    getHearingDatesForMinutes(year: number): Observable<any[]> {
      const xUrl = this.myUrl + '/hearing/minutes/year/' + year;
      return this.http.get<any[]>(xUrl);
    }
    getScheduledCases(hearingId: string): Observable<any[]> {
        const xUrl = this.myUrl + '/case/schedule/current/hearing/' + hearingId;
        return this.http.get<any[]>(xUrl);
    }
    getMeetingLocations(): Observable<any> {
        const xUrl = this.myUrl + '/meetinglocation';
        return this.http.get<any>(xUrl);
    }
}
